import { forwardRef } from 'react';
import { oneLine } from 'common-tags';

import { BackgroundImage } from '@/atoms';

import { styleInjector } from '@/lib/utils';

import type { TypeContainerProps } from './types';

/**
 * El componente Container es totalmente flexible y permite casi cualquier cosa
 */
const BaseContainer = (
  {
    as: HtmlTag = 'div',
    className = '',
    id = '',
    classNameWrapper = '',
    style,
    wrapperSize = '',
    wrapper = false,
    backgroundTop,
    backgroundBottom,
    backgroundImage = '',
    backgroundLazy = true,
    overlay = 0,
    backgroundColor = 'bg-transparent',
    padding = 'px-4 md:py-8 py-4',
    justify = '',
    align = '',
    textAlign = '',
    zIndex = 1,
    children,
  }: TypeContainerProps,
  ref: React.Ref<any>
): JSX.Element => (
  <HtmlTag
    className={oneLine`
      relative flex flex-col
      ${justify}
      ${align}
      ${padding}
      ${textAlign}
      ${className}
      ${backgroundTop || backgroundBottom ? '' : backgroundColor}
    `}
    style={style}
    ref={ref}
    {...(id && {
      id: id,
    })}
  >
    {!(backgroundTop || backgroundBottom) && (
      <BackgroundImage
        backgroundImage={backgroundImage}
        overlay={overlay}
        notLazy={backgroundLazy}
      />
    )}

    {backgroundTop && (
      <div
        className="absolute top-0 left-0 right-0 h-1/2"
        style={{ backgroundColor: backgroundTop.backgroundColor }}
      >
        <BackgroundImage
          backgroundImage={backgroundTop.backgroundImage}
          overlay={backgroundTop.overlay}
          notLazy={backgroundLazy}
        />
      </div>
    )}

    {wrapper ? (
      <div
        className={oneLine`u-wrapper ${wrapperSize} flex flex-col ${justify} ${align} ${textAlign} ${classNameWrapper}`}
        style={{ zIndex: zIndex }}
      >
        {children}
      </div>
    ) : children && (backgroundBottom || backgroundImage || backgroundTop) ? (
      styleInjector({ zIndex: zIndex }, children)
    ) : (
      children
    )}

    {backgroundBottom && (
      <div
        className="absolute bottom-0 left-0 right-0 h-1/2"
        style={{ backgroundColor: backgroundBottom.backgroundColor }}
      >
        <BackgroundImage
          backgroundImage={backgroundBottom.backgroundImage}
          overlay={backgroundBottom.overlay}
          notLazy={backgroundLazy}
        />
      </div>
    )}
  </HtmlTag>
);

export const Container = forwardRef<any, TypeContainerProps>(BaseContainer);
